import {faFilter} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TableColumnType} from 'antd';

import {Locale} from '../../../../provider/locale/locale';
import {TableSorterHookReturnType} from '../../../../util/antd/table/table-sorter-hook';
import {TupleType} from '../../../../util/type';

import {ResponseTemplatesTableRowDataType} from './response-templates-table-type';

enum ResponseTemplatesTableKeyEnum {
    Title = 'title',
    TagGroup = 'tagGroup',
    TagActions = 'tagAction',
    DateCreation = 'dateCreation',
}

export function getResponseTemplateColumnList(
    getSortOrder: TableSorterHookReturnType<ResponseTemplatesTableKeyEnum>['getSortOrder']
): TupleType<TableColumnType<ResponseTemplatesTableRowDataType>, 5> {
    return [
        {
            title: <Locale stringKey="RESPONSE_TEMPLATES__TEMPLATE" />,
            dataIndex: 'title',
            sorter: true,
            sortOrder: getSortOrder(ResponseTemplatesTableKeyEnum.Title),
        },
        {
            title: <Locale stringKey="RESPONSE_TEMPLATES__GROUP" />,
            dataIndex: 'responseTemplateGroup',
            filterIcon: <FontAwesomeIcon icon={faFilter} size="lg" />,
        },
        {
            title: <Locale stringKey="RESPONSE_TEMPLATES__TYPE" />,
            dataIndex: 'responseTemplateType',
            filterIcon: <FontAwesomeIcon icon={faFilter} size="lg" />,
            width: 136,
        },
        {
            title: <Locale stringKey="TABLE__HEADER__DATE_OF_CREATION" />,
            dataIndex: 'dateCreation',
            sorter: true,
            sortOrder: getSortOrder(ResponseTemplatesTableKeyEnum.DateCreation),
        },
        {
            title: <Locale stringKey="RESPONSE_TEMPLATES__GROUP__ACTIONS" />,
            dataIndex: 'templateActions',
            width: 104,
        },
    ];
}

export const withoutGroupItemId = '-1';

// see ResponseTemplateDataType.is_complex
// is_complex === true => command
// is_complex === false => private
export const responseTemplateTypePrivate = 'private';
export const responseTemplateTypeCommand = 'command';
